import { Avatar } from '../ui/catalyst/avatar';
import { getSenderInitials } from './utils';

interface SenderInitialsAvatarProps {
  sender: { name?: string | null; handle?: string | null } | null;
}

export const SenderInitialsAvatar = ({ sender }: SenderInitialsAvatarProps) => {
  const initials = getSenderInitials(sender);
  return (
    <Avatar
      initials={initials}
      alt={sender?.name || sender?.handle || 'Sender'}
      className="h-7 w-7 bg-gray-100 text-gray-400 border border-gray-200 shadow-none"
    />
  );
};
